var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { awsuiGlobalFlagsSymbol, awsuiVisualRefreshFlag } from './internal.js';
export var Mode;
(function (Mode) {
    Mode["Light"] = "light";
    Mode["Dark"] = "dark";
})(Mode || (Mode = {}));
export var Density;
(function (Density) {
    Density["Comfortable"] = "comfortable";
    Density["Compact"] = "compact";
})(Density || (Density = {}));
var MODE_ENTERING_CLASSNAME = 'awsui-mode-entering';
function isKnownMode(mode) {
    var Modes = __assign(__assign({}, Mode), Density);
    return Object.keys(Modes).some(function (key) { return Modes[key] === mode; });
}
function getClassNameByMode(mode) {
    return mode && isKnownMode(mode) ? "awsui-polaris-".concat(mode, "-mode") : null;
}
function isColorModeType(className) {
    var colorModes = Object.keys(Mode).map(function (key) { return Mode[key]; });
    return colorModes.some(function (value) { return new RegExp("awsui-polaris-".concat(value, "-mode")).test(className); });
}
function isDensityModeType(className) {
    var densityModes = Object.keys(Density).map(function (key) { return Density[key]; });
    return densityModes.some(function (value) { return new RegExp("awsui-polaris-".concat(value, "-mode")).test(className); });
}
export function applyMode(mode, target) {
    if (target === void 0) { target = document.body; }
    if (mode && !isKnownMode(mode)) {
        console.warn("Mode \"".concat(mode, "\" is not supported"));
        return;
    }
    var modeClassName = getClassNameByMode(mode);
    target.className.split(' ').forEach(function (className) {
        if (isColorModeType(className)) {
            target.classList.remove(className);
        }
    });
    if (modeClassName) {
        target.classList.add(modeClassName);
        target.classList.add(MODE_ENTERING_CLASSNAME);
    }
    requestAnimationFrame(function () {
        target.classList.remove(MODE_ENTERING_CLASSNAME);
    });
}
export function applyDensity(density, target) {
    if (target === void 0) { target = document.body; }
    if (density && !isKnownMode(density)) {
        console.warn("Density \"".concat(density, "\" is not supported"));
        return;
    }
    var modeClassName = getClassNameByMode(density);
    target.className.split(' ').forEach(function (className) {
        if (isDensityModeType(className)) {
            target.classList.remove(className);
        }
    });
    if (modeClassName) {
        target.classList.add(modeClassName);
    }
}
export function disableMotion(disabled, target) {
    if (target === void 0) { target = document.body; }
    if (disabled) {
        target.classList.add('awsui-motion-disabled');
    }
    else {
        target.classList.remove('awsui-motion-disabled');
    }
}
export function deactivateVisualRefresh() {
    window[awsuiVisualRefreshFlag] = function () { return false; };
}
export function isVisualRefreshActive() {
    var _a;
    return !!document.querySelector('.awsui-visual-refresh') || !!((_a = window[awsuiVisualRefreshFlag]) === null || _a === void 0 ? void 0 : _a.call(window));
}
export function isAppLayoutToolbarActive() {
    var _a, _b;
    return (isVisualRefreshActive() &&
        !!(((_a = window[awsuiGlobalFlagsSymbol]) === null || _a === void 0 ? void 0 : _a.appLayoutWidget) || ((_b = window[awsuiGlobalFlagsSymbol]) === null || _b === void 0 ? void 0 : _b.appLayoutToolbar)));
}
